export const isEmpty = (a) => (a==null) || (a==='') || (Array.isArray(a) && a.length===0)

export const isEmptyObject = (a) => isEmpty(a) || (Object.keys(a).length===0)

export const isString = (a) => (typeof a ==='string')

export const isBoolean = (a) => (typeof a ==='boolean')

export const isObject = (a) => (a!==null && typeof a ==='object')

export const isNumeric = (a) => (!isNaN(parseFloat(a)) && isFinite(a))

export const cleanObject = (obj) => {
    let v = {}
    for (let k in obj) {
        let a = obj[k]
        if (isEmpty(a)) continue
        v[k] = a
    }
    return v
}

export const clearObject = (obj) => {
    if (!obj) return obj
    for (let k in obj) {
        delete obj[k]
    }
    return obj
}

export const coalesce = function() {
    return Array.from(arguments).find((a) => !isEmpty(a))
}

export const pickObject = (obj={}, key, defaultValue) => {
    if (!obj || !key) return defaultValue

    let keys = (key || '.').split('.')
    for (let i=0, n=keys.length; i<n; i++) {
        let k = keys[i]
        obj = obj[k]
        if (obj===undefined || obj===null) break
    }

    return (obj===undefined || obj===null)
        ? defaultValue
        : obj
}

export const isEquals = function equals (o, p) {

    var keysO = Object.keys(o).sort()
    var keysP = Object.keys(p).sort()

    if (keysO.length !== keysP.length) return false
    if (keysO.join('') !== keysP.join('')) return false

    for (var i=0, n=keysO.length; i<n; i++) {
        var k = keysO[i]
        var a = o[k]
        var b = p[k]

        if (Array.isArray(a)) {
            if (!(Array.isArray(b))) return false
            if (equals(a.sort(),b.sort())===false) return false
        }
        else if (isObject(a)) {
            if (!(isObject(b))) return false
            if (a===o) {
                if (b!==p) return false
            }
            else if (equals(a,b)===false) {
                return false
            }
        }
        else if (a !== b) {
            return false
        }
    }
    return true
}

export const stringFrom = (v) => {
    return (v===undefined || v===null)
        ? ''
        : String(v)
}

export const numberFrom = (v, dv=null) => {
    return isNumeric(v) ? parseFloat(v) : dv
}

export const arrayFrom = (v) => {
    if (v===undefined || v===null) return []

    return Array.isArray(v) ? v : [v]
}

export const arrayRemove = (arr, v) => {
    if (!Array.isArray(arr)) return arr

    let isfn = typeof v==='function'
    let i = isfn
        ? arr.findIndex(v)
        : arr.indexOf(v)
    if (i<0) return arr

    arr.splice(i, 1)
    return arr
}

export const arrayInsert = (arr, v, x) => {
    if (!Array.isArray(arr)) return arr

    let isfn = typeof v==='function'
    let i = isfn
        ? arr.findIndex(v)
        : arr.indexOf(v)
    if (i<0) {
        arr.push(isfn ? (x || v) : v)
    }

    return arr
}

export const arrayToggle = (arr, v, x) => {
    if (!Array.isArray(arr)) return arr

    let isfn = typeof v==='function'
    let i = isfn
        ? arr.findIndex(v)
        : arr.indexOf(v)
    if (i<0) {
        arr.push(isfn ? (x || v) : v)
    } else {
        arr.splice(i, 1)
    }

    return arr
}

export const arrayUnique = (arr) => {
    return arr.reduce( (x, a) => {
        if (x.indexOf(a)>=0) return x
        x.push(a)
        return x
    }, [])
}

export const arraySplit = (arr, size) => {
    let a = [].concat(arr)
    let b = []
    while(a.length) {
        b.push(a.splice(0, size))
    }
    return b
}

export const sleep = (ms) => {
    return new Promise(f => setTimeout(f, ms))
}

export const bufferedFn = (fn, ms=1000) => {
    var tmId

    return (...args) => {
        if (tmId) clearTimeout(tmId)

        tmId = setTimeout(() => {
            fn.apply(null, args)
        }, ms)
    }
}

export const sortFn = (fn, asc = 1) => {
    return (a,b) => {
        let ai = fn(a)
        let bi = fn(b)
        return ai > bi ? asc :
            ai < bi ? -asc :
            0
    }
}